import React from "react";
import "./Tour.css";
import { Link } from "react-router-dom";

const Tour = () => {
	return (
		<div className='uiowa-tour py-4'>
			<div className='content  d-flex align-items-center justify-content-space'>
				<p>SEE IOWA CITY FOR YOURSELF</p>
				<p>Get a feel for campus on a guided, virtual tour.</p>
				<Link className='btnUiowa d-flex  gap-3'>
					EXPLORE IOWA CITY
					<span>
						<i
							className='fa fa-arrow-right'
							style={{ color: "#fff" }}
							aria-hidden='true'
						></i>
					</span>
				</Link>
			</div>
		</div>
	);
};

export default Tour;
